import React from 'react';
import { truncateParty, formatNumber } from '../../utils/formatters';

export function ValidatorRow({ validator, rank, showRewards = false, onClick, highlighted = false }) {
  const hasRewards = validator.rewards !== undefined && validator.rewards !== null;

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: showRewards
        ? '36px minmax(0, 1.5fr) 100px 70px'
        : '36px minmax(0, 1fr) minmax(0, 1fr) 70px',
      gap: '16px',
      padding: '12px 16px',
      borderBottom: '1px solid var(--border-subtle)',
      alignItems: 'center',
      transition: 'background 0.15s ease',
      cursor: 'pointer',
      background: highlighted ? 'var(--accent-muted)' : 'transparent',
    }}
    onClick={() => onClick && onClick(validator)}
    onMouseEnter={(e) => { if (!highlighted) e.currentTarget.style.background = 'rgba(255, 255, 255, 0.02)'; }}
    onMouseLeave={(e) => { if (!highlighted) e.currentTarget.style.background = 'transparent'; }}
    >
      <div style={{
        fontSize: '14px',
        color: rank <= 3 ? 'var(--text-primary)' : 'var(--text-tertiary)',
        fontFamily: 'var(--font-mono)',
        fontWeight: rank <= 3 ? '700' : '400',
      }}>#{rank}</div>
      <div style={{ minWidth: 0 }}>
        <div style={{ color: 'var(--text-primary)', fontSize: '13px', fontWeight: '600', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {validator.name || 'Validator'}
        </div>
        <div style={{ color: 'var(--text-disabled)', fontSize: '10px', fontFamily: 'var(--font-mono)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {validator.contact || validator.contactPoint || truncateParty(validator.party)}
        </div>
      </div>
      {showRewards && hasRewards ? (
        <div style={{
          textAlign: 'right',
          minWidth: 0,
        }}>
          <div style={{
            color: 'var(--text-secondary)',
            fontSize: '13px',
            fontWeight: '600',
            fontFamily: 'var(--font-mono)',
          }}>
            {formatNumber(validator.rewards)} CC
          </div>
        </div>
      ) : (
        <div style={{ color: 'var(--text-tertiary)', fontSize: '11px', fontFamily: 'var(--font-mono)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0 }}>
          {validator.contact || validator.contactPoint || '—'}
        </div>
      )}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        justifyContent: 'flex-end',
      }}>
        <span style={{
          width: '6px',
          height: '6px',
          borderRadius: '50%',
          background: 'var(--text-primary)',
          flexShrink: 0,
        }} />
        <span className="hide-mobile" style={{
          fontSize: '10px',
          color: 'var(--text-tertiary)',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
        }}>ACTIVE</span>
      </div>
    </div>
  );
}
